import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable, of, tap } from 'rxjs';
import { Injectable } from '@angular/core';
import { Genre, ResearchCreator, ResearchLink, Video } from '../models/research';
import { Creator } from '../models/creator';

@Injectable({ providedIn: 'root' })
export class ResearchService {
  researchLinksCache: ResearchLink[] = [];
  creatorsCache: ResearchCreator[] = [];

  constructor(public http: HttpClient) {}

  getCreators(genre: Genre): Observable<ResearchCreator[]> {

    // if (this.creatorsCache.length > 0) {
    //   return of(this.creatorsCache);
    // }

    const url = `${environment.apiUrl}creators?genre=${genre}`;
    return this.http.get<ResearchCreator[]>(url).pipe(
      tap((data) => (this.creatorsCache = data))
    );
  }

  getResearchLinks(genre: Genre): Observable<ResearchLink[]> {
    if (this.researchLinksCache.length > 0) {
      return of(this.researchLinksCache);
    }

    const url = `${environment.apiUrl}researchlinks?genre=${genre}`;
    return this.http.get<ResearchLink[]>(url).pipe(
      tap((data) => (this.researchLinksCache = data))
    );
  }

  updateResearchLink(link: ResearchLink): Observable<ResearchLink> {
    const url = `${environment.apiUrl}researchlinks`;
    return this.http.patch<ResearchLink>(url, link);
  }

  updateResearchCreator(creator: ResearchCreator): Observable<ResearchCreator> {
    const url = `${environment.apiUrl}researchcreators/${creator.id}`;
    return this.http.patch<ResearchCreator>(url, creator);
  }

  getPaidAdVideos(genre: Genre, startDate: string, endDate: string): Observable<Video[]> {
    const url = `${environment.apiUrl}paidAdVideos?sd=${startDate}&ed=${endDate}&genre=${genre}`;
    console.log(url);
    return this.http.get<Video[]>(url);
  }

  getEmailChangedCreators(): Observable<ResearchCreator[]> {
    const url = `${environment.apiUrl}emailchanged`;
    return this.http.get<ResearchCreator[]>(url);
  }

  cleanEmailInBio(creatorId: string): Observable<string> {
    const url = `${environment.apiUrl}cleanemailinbio?id=${encodeURIComponent(creatorId)}`;
    return this.http.get(url, { responseType: 'text' });
  }

  deleteCreator(creatorId: string): Observable<string> {
    const url = `${environment.apiUrl}creators/${creatorId}`;
    return this.http.delete(url, { responseType: 'text' });
  }

  addCreator(tiktok: string, genre: Genre): Observable<ResearchCreator> {
    const url = `${environment.apiUrl}creator`;
    return this.http.post<ResearchCreator>(url, { tiktok, genre });
  }

  deleteLink(linkId: string): Observable<string> {
    const url = `${environment.apiUrl}researchlinks/${linkId}`
    return this.http.delete(url, { responseType: 'text' });
  }


}
